export class HideCarouselButtonsWidget {
  private sideButtonsCarousels: NodeListOf<Element> | undefined;
  private bottomButtonsCarousels: NodeListOf<Element> | undefined;

  constructor() {}

  public init(): void {
    this.sideButtonsCarousels = document.querySelectorAll('.carousel.carousel-side-buttons');
    this.bottomButtonsCarousels = document.querySelectorAll('.carousel.carousel-bottom-buttons');
    this.hideSideControls();
    this.hideBottomControls();
  }

  private hideSideControls(): void {
    if (!this.sideButtonsCarousels || !this.sideButtonsCarousels.length) return;

    this.sideButtonsCarousels.forEach((carousel) => {
      const sliderItems = carousel.querySelectorAll('.carousel-item');
      const nextButton = carousel.querySelector('.carousel-control-next.side-button');
      const prevButton = carousel.querySelector('.carousel-control-prev.side-button');
      const indicatorsWrapper = carousel.querySelector('.carousel-indicators');

      if (sliderItems?.length <= 1) {
        nextButton?.classList.add('d-none');
        prevButton?.classList.add('d-none');
        indicatorsWrapper?.classList.add('d-none');
      }
    });
  }

  private hideBottomControls(): void {
    if (!this.bottomButtonsCarousels || !this.bottomButtonsCarousels.length) return;

    this.bottomButtonsCarousels.forEach((carousel) => {
      const sliderItems = carousel.querySelectorAll('.carousel-item');
      const controlWrapper = carousel.querySelector('.carousel-bottom-controls');

      if (sliderItems?.length <= 1) {
        controlWrapper?.classList.add('d-none');
      }
    });
  }
}
